export { default } from './PremiumChip';
